import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";


import { CVEDetail, deleteReferenceApi } from "../../actions/cveInformation";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const EditCve = () => {
  const cveData = useSelector(
    (state) => state?.cveInformation?.cveDetails?.data
  );
  const userData = useSelector(
    (state) => state?.auth?.userData || state?.auth?.user
  );
  const navigate = useHistory();
  const dispatch = useDispatch();
  const { cveId: cveID } = useParams();
  const [cveId, setCveId] = useState(cveID);
  const [editingDescriptionStatus, setEditingDescriptionStatus] = useState(false);
  const [editing, setEditing] = useState(false);
  const [addingNewReference, setAddingNewReference] = useState(false);
  const [description, setDescription] = useState("");
  const [publishedDate, setPublishedDate] = useState(null);
  const [lastModifiedDate, setLastModifiedDate] = useState(null);
  const [editingPublishedDate, setEditingPublishedDate] = useState(false);
  const [editingLastModifiedDate, setEditingLastModifiedDate] = useState(false);
  const [referenceUrl, setReferenceUrl] = useState("");
  const [referenceName, setReferenceName] = useState("");
  const [referenceSource, setReferenceSource] = useState("");
  const [referenceTags, setReferenceTags] = useState([]);
  const [newTag, setNewTag] = useState("");

  // Check if user is super admin
  // const isSuperAdmin = userData?.role === 'superAdmin' || userData?.userType === 'superAdmin' || userData?.isAdmin === true;
  const isSuperAdmin = useSelector((state) => state?.auth?.user?.accessLevel);
  useEffect(() => {
    CVEDetail(dispatch, cveId);
  }, [dispatch, cveId]);

  useEffect(() => {
    if (cveData?.publishedDate) {
      setPublishedDate(new Date(cveData.publishedDate));
    }
    if (cveData?.lastModifiedDate) {
      setLastModifiedDate(new Date(cveData.lastModifiedDate));
    }
  }, [cveData]);

  function deleteReference(referenceId) {
    deleteReferenceApi(dispatch, cveData?._id, referenceId);
  }

  const handleAddTag = () => {
    if (newTag.trim()) {
      setReferenceTags([...referenceTags, newTag.trim()]);
      setNewTag("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setReferenceTags(referenceTags.filter(tag => tag !== tagToRemove));
  };

  const handleSaveReference = () => {
    // Handle save reference logic here
    setAddingNewReference(false);
  };

  const handleSaveDescription = () => {
    // Handle save description logic here
    setEditingDescriptionStatus(false);
  };

  const handleSavePublishedDate = () => {
    // Handle save published date logic here
    setEditingPublishedDate(false);
  };

  const handleSaveLastModifiedDate = () => {
    // Handle save last modified date logic here
    setEditingLastModifiedDate(false);
  };

  // Function to render empty state message
  const renderEmptyState = (message) => (
    <div className="text-center p-4 text-muted bg-light rounded">
      <i className="fa fa-folder-open-o fa-2x mb-2"></i>
      <p className="mb-0 small">{message}</p>
    </div>
  );

  const cvePageStyles = `
    .cve-header {
      background: linear-gradient(45deg, #453acd, #6a5acd);
      color: white;
      padding: 20px;
      border-radius: 8px;
      margin-bottom: 20px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    }
    .cve-card {
      border: none;
      box-shadow: 0 2px 10px rgba(0,0,0,0.05);
      border-radius: 8px;
      margin-bottom: 20px;
      transition: transform 0.2s;
    }
    .cve-card:hover {
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    }
    .cve-card-header {
      background-color: transparent;
      border-bottom: 1px solid #eee;
      padding: 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cve-card-title {
      font-size: 1.1rem;
      font-weight: 600;
      color: #333;
      margin: 0;
    }
    .cve-label {
      font-weight: 600;
      color: #6c757d;
      font-size: 0.85rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 5px;
    }
    .cve-value {
      font-size: 1rem;
      color: #212529;
      line-height: 1.5;
    }
    .reference-card {
      border: 1px solid #eee;
      border-radius: 6px;
      padding: 15px;
      height: 100%;
      background: #fff;
      transition: all 0.2s;
    }
    .reference-card:hover {
      border-color: #453acd;
      transform: translateY(-2px);
    }
    .severity-badge {
      display: inline-block;
      padding: 0.35em 0.65em;
      font-size: 0.75em;
      font-weight: 700;
      line-height: 1;
      color: #fff;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25rem;
    }
    .edit-btn-icon {
      color: #453acd;
      background: rgba(69, 58, 205, 0.1);
      border: none;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
    }
    .edit-btn-icon:hover {
      background: #453acd;
      color: white;
    }
  `;

  return (
    <>
      <style>{cvePageStyles}</style>

      {/* Modals placed here (same as before) */}
      {addingNewReference && isSuperAdmin && (
        <div className="modal fade Form-Wizard-modal d-block show" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h5 className="modal-title">Add New Reference</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setAddingNewReference(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body p-4">
                <div className="form-group mb-3">
                  <label className="form-label font-weight-bold">Reference URL</label>
                  <input
                    type="text"
                    className="form-control"
                    value={referenceUrl}
                    onChange={(e) => setReferenceUrl(e.target.value)}
                    placeholder="https://example.com"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label font-weight-bold">Reference Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={referenceName}
                    onChange={(e) => setReferenceName(e.target.value)}
                    placeholder="e.g. Official Patch Note"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label font-weight-bold">Reference Source</label>
                  <input
                    type="text"
                    className="form-control"
                    value={referenceSource}
                    onChange={(e) => setReferenceSource(e.target.value)}
                    placeholder="e.g. Vendor Website"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label font-weight-bold">Tags</label>
                  <div className="d-flex flex-wrap gap-2 mb-2">
                    {referenceTags.map((tag, index) => (
                      <span key={index} className="badge badge-light border px-2 py-1">
                        {tag}
                        <span
                          className="ml-2 cursor-pointer text-danger"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleRemoveTag(tag)}
                        >
                          ×
                        </span>
                      </span>
                    ))}
                  </div>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={newTag}
                      onChange={(e) => setNewTag(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleAddTag()}
                      placeholder="Add a tag..."
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        onClick={handleAddTag}
                      >
                        Add Tag
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <button
                    className="btn btn-secondary mr-2"
                    onClick={() => setAddingNewReference(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    style={{ backgroundColor: "#08283f" }}
                    onClick={handleSaveReference}
                  >
                    Save Reference
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {editing && isSuperAdmin && (
        <div className="modal fade Form-Wizard-modal d-block show" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h5 className="modal-title">Edit {editing.field}</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setEditing(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body p-4">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    value={editing.value || ''}
                    onChange={(e) => {
                      setEditing({
                        ...editing,
                        value: e.target.value
                      });
                    }}
                  />
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-secondary mr-2"
                    onClick={() => setEditing(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    style={{ backgroundColor: "#08283f" }}
                    onClick={() => {
                      // Handle save logic here
                      setEditing(false);
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingDescriptionStatus && isSuperAdmin && (
        <div className="modal fade Form-Wizard-modal d-block show" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h5 className="modal-title">Edit Description</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setEditingDescriptionStatus(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body p-4">
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows="8"
                    value={description || cveData?.cveDescription}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ resize: "vertical" }}
                  />
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-secondary mr-2"
                    onClick={() => setEditingDescriptionStatus(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    style={{ backgroundColor: "#08283f" }}
                    onClick={handleSaveDescription}
                  >
                    Save Description
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingPublishedDate && isSuperAdmin && (
        <div className="modal fade Form-Wizard-modal d-block show" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h5 className="modal-title">Edit Published Date</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setEditingPublishedDate(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body p-4">
                <div className="form-group">
                  <DatePicker
                    selected={publishedDate}
                    onChange={(date) => setPublishedDate(date)}
                    className="form-control w-100"
                    dateFormat="yyyy-MM-dd"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-secondary mr-2"
                    onClick={() => setEditingPublishedDate(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    style={{ backgroundColor: "#08283f" }}
                    onClick={handleSavePublishedDate}
                  >
                    Save Date
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingLastModifiedDate && isSuperAdmin && (
        <div className="modal fade Form-Wizard-modal d-block show" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h5 className="modal-title">Edit Last Modified Date</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setEditingLastModifiedDate(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body p-4">
                <div className="form-group">
                  <DatePicker
                    selected={lastModifiedDate}
                    onChange={(date) => setLastModifiedDate(date)}
                    className="form-control w-100"
                    dateFormat="yyyy-MM-dd"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-secondary mr-2"
                    onClick={() => setEditingLastModifiedDate(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    style={{ backgroundColor: "#08283f" }}
                    onClick={handleSaveLastModifiedDate}
                  >
                    Save Date
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container-fluid py-3">
        {/* Breadcrumb Header */}
        <div className="block-header mb-4">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">CVE Details</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb bg-transparent p-0 mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/" >Home</Link>
                  </li>
                  <li className="breadcrumb-item text-white active" aria-current="page">
                    CVE Information
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="row clearfix">
          {/* Left Column: Basic Info & Description */}
          <div className="col-lg-8 col-md-12">
            <div className="card cve-card">
              <div className="body p-4">
                <div className="d-flex align-items-center mb-4">
                  <div className="mr-3">
                    <span className="badge badge-info p-2" style={{ fontSize: '1em', background: '#eef2ff', color: '#453acd' }}>
                      <i className="fa fa-shield mr-1"></i> CVE ID
                    </span>
                  </div>
                  <input
                    value={cveId}
                    onChange={(e) => setCveId(e.target.value)}
                    className="form-control form-control-lg border-0 font-weight-bold"
                    style={{ fontSize: '1.5rem', color: '#333', padding: 0 }}
                  />
                </div>

                {cveData ? (
                  <>
                    <div className="mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="cve-label text-uppercase">Description</h6>
                        {isSuperAdmin && (
                          <button className="edit-btn-icon" onClick={() => setEditingDescriptionStatus(true)} title="Edit Description">
                            <i className="fa fa-pencil"></i>
                          </button>
                        )}
                      </div>
                      <div className="bg-light p-3 rounded text-muted" style={{ lineHeight: '1.6' }}>
                        {cveData?.cveDescription || renderEmptyState("No description available.")}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                          <div>
                            <div className="cve-label">Published Date</div>
                            <div className="cve-value">
                              <i className="fa fa-calendar-o mr-2 text-muted"></i>
                              {cveData?.publishedDate || "N/A"}
                            </div>
                          </div>
                          {isSuperAdmin && (
                            <button className="edit-btn-icon btn-sm" onClick={() => setEditingPublishedDate(true)}>
                              <i className="fa fa-pencil"></i>
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                          <div>
                            <div className="cve-label">Last Modified Date</div>
                            <div className="cve-value">
                              <i className="fa fa-clock-o mr-2 text-muted"></i>
                              {cveData?.lastModifiedDate || "N/A"}
                            </div>
                          </div>
                          {isSuperAdmin && (
                            <button className="edit-btn-icon btn-sm" onClick={() => setEditingLastModifiedDate(true)}>
                              <i className="fa fa-pencil"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  renderEmptyState("Loading details...")
                )}
              </div>
            </div>

            {/* Exploits Section */}
            {cveData?.exploits?.length > 0 && (
              <div className="card cve-card">
                <div className="cve-card-header">
                  <h5 className="cve-card-title">Known Exploits</h5>
                </div>
                <div className="body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th>Description</th>
                          <th>Type</th>
                          <th>Platform</th>
                          <th>Author</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cveData.exploits.map((cveItem) => (
                          <tr key={cveItem._id}>
                            <td style={{ maxWidth: '300px' }} className="text-truncate" title={cveItem.description}>
                              {cveItem.description}
                            </td>
                            <td><span className="badge badge-secondary">{cveItem.type}</span></td>
                            <td>{cveItem.platform}</td>
                            <td>{cveItem.author}</td>
                            <td>
                              <a
                                href={cveItem.downloadUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary"
                              >
                                Download
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* References Section */}
            {cveData && (
              <div className="card cve-card">
                <div className="cve-card-header">
                  <h5 className="cve-card-title">References</h5>
                  {isSuperAdmin && (
                    <button
                      onClick={() => setAddingNewReference(true)}
                      className="btn btn-sm btn-primary shadow-sm"
                    >
                      <i className="fa fa-plus mr-1"></i> Add Reference
                    </button>
                  )}
                </div>
                <div className="body p-4">
                  {cveData["references"]?.length > 0 ? (
                    <div className="row">
                      {cveData["references"].map((reference, i) => (
                        <div key={i} className="col-md-6 mb-3">
                          <div className="reference-card d-flex flex-column">
                            <div className="d-flex justify-content-between mb-2">
                              <h6 className="font-weight-bold text-primary mb-0 text-truncate" title={reference["name"]}>
                                {reference["name"]}
                              </h6>
                              {isSuperAdmin && (
                                <div className="dropdown">
                                  <button className="btn btn-link btn-sm p-0 text-muted" type="button" data-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                  </button>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <button className="dropdown-item" onClick={() => setEditing({
                                      model: reference["model"],
                                      _id: reference["_id"],
                                      field: "name",
                                      value: reference["name"],
                                      fieldType: "text",
                                    })}>Edit Name</button>
                                    <button className="dropdown-item text-danger" onClick={() => deleteReference(reference["_id"])}>Delete</button>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="mb-2 small text-muted">
                              <i className="fa fa-globe mr-1"></i> {reference["refsource"]}
                            </div>
                            <div className="mb-3 small">
                              <a href={reference["url"]} target="_blank" rel="noopener noreferrer" className="text-break text-decoration-none">
                                {reference["url"]}
                              </a>
                            </div>
                            <div className="mt-auto">
                              {reference["tags"]?.map((tag, idx) => (
                                <span key={idx} className="badge badge-light border mr-1 mb-1">{tag}</span>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    renderEmptyState("No references found.")
                  )}
                </div>
              </div>
            )}

          </div>

          {/* Right Column: Metrics & Targets */}
          <div className="col-lg-4 col-md-12">

            {/* CVSS Score Card */}
            {cveData?.impact?.baseMetricV3 && (
              <div className="card cve-card">
                <div className="cve-card-header">
                  <h5 className="cve-card-title">CVSS v3.x Severity</h5>
                </div>
                <div className="body p-4 text-center">
                  <div className="mb-3">
                    <div style={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      background: `conic-gradient(${cveData["impact"]["baseMetricV3"]["cvssV3"]?.baseScore >= 7 ? '#dc3545' : '#ffc107'} ${cveData["impact"]["baseMetricV3"]["cvssV3"]?.baseScore * 10}%, #f1f3f5 0)`,
                      margin: '0 auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative'
                    }}>
                      <div style={{
                        width: '85px',
                        height: '85px',
                        background: 'white',
                        borderRadius: '50%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <span style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#333' }}>
                          {cveData["impact"]["baseMetricV3"]["cvssV3"]?.baseScore}
                        </span>
                        <span style={{ fontSize: '0.7rem', color: '#6c757d', textTransform: 'uppercase' }}>Base Score</span>
                      </div>
                    </div>
                  </div>

                  <div className="badge badge-dark px-3 py-2 mb-3" style={{ fontSize: '1rem' }}>
                    {cveData["impact"]["baseMetricV3"]["cvssV3"]?.baseSeverity}
                  </div>

                  <div className="d-flex justify-content-between border-top pt-3 text-left">
                    <div>
                      <div className="small text-muted">Vector</div>
                      <div className="font-weight-bold" style={{ fontSize: '0.8rem' }}>
                        {cveData["impact"]["baseMetricV3"]["cvssV3"]?.vectorString}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2 text-left">
                    <div>
                      <div className="small text-muted">Exploitability</div>
                      <div className="font-weight-bold">{cveData["impact"]["baseMetricV3"]?.exploitabilityScore}</div>
                    </div>
                    <div className="text-right">
                      <div className="small text-muted">Impact</div>
                      <div className="font-weight-bold">{cveData["impact"]["baseMetricV3"]?.impactScore}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* CISA & Targeted Info */}
            {cveData && (
              (cveData.targetedCountries?.length > 0 || cveData.industries?.length > 0 || cveData.malwareFamilies?.length > 0) && (
                <div className="card cve-card">
                  <div className="cve-card-header">
                    <h5 className="cve-card-title">Threat Intelligence</h5>
                  </div>
                  <div className="body p-3">
                    {cveData.targetedCountries?.length > 0 && (
                      <div className="mb-3">
                        <h6 className="small text-muted text-uppercase font-weight-bold mb-2">Targeted Countries</h6>
                        <div className="d-flex flex-wrap">
                          {cveData.targetedCountries.map((country, idx) => (
                            <span key={idx} className="badge badge-light border mr-1 mb-1">{country}</span>
                          ))}
                        </div>
                      </div>
                    )}

                    {cveData.industries?.length > 0 && (
                      <div className="mb-3">
                        <h6 className="small text-muted text-uppercase font-weight-bold mb-2">Targeted Industries</h6>
                        <div className="d-flex flex-wrap">
                          {cveData.industries.map((industry, idx) => (
                            <span key={idx} className="badge badge-light border mr-1 mb-1">{industry}</span>
                          ))}
                        </div>
                      </div>
                    )}

                    {cveData.malwareFamilies?.length > 0 && (
                      <div>
                        <h6 className="small text-muted text-uppercase font-weight-bold mb-2">Malware Families</h6>
                        <div className="d-flex flex-wrap">
                          {cveData.malwareFamilies.map((malware, idx) => (
                            <span key={idx} className="badge badge-danger text-white mr-1 mb-1">{malware}</span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

          </div>
        </div>
      </div>
    </>
  );
};

export default EditCve;
